import { AnyAction } from '@reduxjs/toolkit'
import { keyBy } from 'lodash'

import { FETCH_GROUPS_SUCCESS } from './actionTypes'

type OrganizationGroupsPageState = {
  byId: Record<string, unknown>
}

export const initialState: OrganizationGroupsPageState = { byId: {} }

export default (state = initialState, action: AnyAction): OrganizationGroupsPageState => {
  switch (action.type) {
    case FETCH_GROUPS_SUCCESS: {
      return { ...state, byId: { ...state.byId, ...keyBy(action.response, 'id') } }
    }

    default: {
      return state
    }
  }
}
